import { useShouldShowOwFR2R } from "@faire/deprecated-retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireR2R/useShouldShowOwFR2R";
import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { OpenWithFaireShareLinkWidget } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireShareLinkWidget";
import { Core } from "@faire/design-tokens";
import { trackOpenWithFaireRetailerReferralCtaClick } from "@faire/web-api--source/events/openWithFaire/click/retailerReferralCta";
import retailerReferrals from "@faire/web-api--source/routes/www/user/retailer-referrals";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { FC } from "react";
import styled from "styled-components";

export const ShareOffer: FC = () => {
  const { shouldShowOwFR2R } = useShouldShowOwFR2R();
  const { pageState } = useGetFaireAcademyPageState();

  if (shouldShowOwFR2R) {
    return (
      <Button
        linkTo={retailerReferrals()}
        onClick={() =>
          trackOpenWithFaireRetailerReferralCtaClick(
            pageState,
            OWF_SECTION_NAME.FOOTER_CARD
          )
        }
        variant="secondary"
      >
        <StrictLocalMsg
          id="yn4mLm"
          defaultMessage="Refer a new store owner"
          description={{
            text: "CTA text for the footer card of the Open with Faire landing page, for logged in & established customers",
            img: "https://cdn.faire.com/fastly/ff47ec9a94bf1bbfb760806a3b916b74ad732d9fda69d349cb11f81af7156d39.png",
          }}
        />
      </Button>
    );
  }

  return (
    <ShareLinkWrapper align="center">
      <Typography
        variant="subheadingSansMedium"
        color={Core.text.inverse}
        align="center"
      >
        <StrictLocalMsg
          id="opVstq"
          defaultMessage="Share your referral link"
          description={{
            text: "CTA text for the footer card of the Open with Faire landing page, for logged in & established customers",
            img: "https://cdn.faire.com/fastly/ff47ec9a94bf1bbfb760806a3b916b74ad732d9fda69d349cb11f81af7156d39.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <OpenWithFaireShareLinkWidget />
    </ShareLinkWrapper>
  );
};

const ShareLinkWrapper = styled(Column)`
  min-width: 400px;

  ${responsiveMediaQueries.mobile} {
    min-width: 100%;
  }
`;
